import { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import { MdEmail, MdFamilyRestroom } from 'react-icons/md';
import { format } from 'date-fns';
import baseURL from '../../config/api';
import { BsFillTelephoneFill, BsSearch } from 'react-icons/bs';
import { RiArrowDownSFill } from 'react-icons/ri';
import { RxCross1 } from 'react-icons/rx';
import Pagination from '../../components/Pagination';
import { formatUSPhone } from '../../utils/phoneFormatter';
import useGroup from '../../hook/useGroup';
import Cookies from 'js-cookie';
import PdfDirectoryExport from '../../components/PdfDirectoryExport';
import { fetchAllMembersForExport } from '../../services/Member';
import useAuth from '../../hook/useAuth';
import ImportView from '../familyMembers/ImportView';

const AdminMemberList = () => {
    const token = Cookies.get("token-my-cdir");
    const navigate = useNavigate();
    const { auth }: any = useAuth();
    const { selectedGroupId, isSuperAdmin }: any = useGroup();
    const location = useLocation();
    const pathRoot = isSuperAdmin ? "superadmin" : "admin";
    const [searchValue, setSearchValue] = useState<string>("");
    const [searchTableData, setSearchTableData] = useState<any[]>([]);
    const [displayFilter, setDisplayFilter] = useState<boolean>(false);
    const [memberFilterValue, setMemberFilterValue] = useState(0);
    const [isDataLoaded, setIsDataLoaded] = useState(false);
    const [paginationModel, setPaginationModel] = useState<{ page: number, size: number }>({
        page: 0,
        size: 10,
    });
    const [totalLength, setTotalLength] = useState<number>(0);
    const [selectedFilter, setSelectedFilter] = useState<string>("Member Name");
    const [isFirstTime, setIsFirstTime] = useState<boolean>(true);
    const [showEntries, setShowEntries] = useState<number>(10);

    useEffect(() => {
        if (!isFirstTime) {
            setSelectedFilter("Member Name");
            setMemberFilterValue(0);
            if (searchValue !== "") {
                setSearchValue("");
                setIsFirstTime(false);
            }
            else {
                setPaginationModel({
                    page: 0,
                    size: 10
                })
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedGroupId])

    useEffect(() => {
        if (searchValue === "" && !isFirstTime) {
            const newPaginationModel = {
                page: 0,
                size: paginationModel.size,
            };

            setPaginationModel(newPaginationModel);
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchValue]);

    useEffect(() => {
        if (searchValue === "") {
            setIsFirstTime(false)
            apiCall(paginationModel);
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [paginationModel])

    const apiCall = (newPaginationModel: { page: number, size: number }) => {
        if (selectedGroupId > 0) {
            setIsDataLoaded(true);
            fetch(`${baseURL}member/GetMemberReportByGroupIdPaging/${selectedGroupId},${newPaginationModel.page},${newPaginationModel.size}`, {
                headers: {
                    Authorization: `Bearer ${token?.toString()}`
                }
            })
                .then((res) => res.json())
                .then((data) => {
                    const result = data.memberReport.map((item: any) => {
                        return {
                            ...item,
                            name: item.firstName + " " + item.lastName,
                            birthday: item?.birthday ? format(new Date(item?.birthday), "MM/dd/yyyy") : "No data",
                            imagePath: item?.imagePath ? `${baseURL}commonFile/Get?name=${item.imagePath}` : "./images/user-default.jpg",
                            address: `${item?.street}, ${item?.city} ${item?.state}, ${item?.country}-${item?.zip}`,
                        };
                    })

                    setSearchTableData(result);
                    setTotalLength(data.count);
                    setIsDataLoaded(false);

                }).catch((error) => {
                    console.log(error);
                    setIsDataLoaded(false);
                    setSearchTableData([]);
                    setTotalLength(0);
                });
        }
        else {
            setIsDataLoaded(false);
            setSearchTableData([]);
            setTotalLength(0);
        }

    }

    useEffect(() => {
        if (location.state?.refresh) {
            apiCall(paginationModel);
            navigate(location.pathname, { replace: true, state: {} });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.state]);

    useEffect(() => {
        let timeOutId: NodeJS.Timeout;

        if (searchValue !== "") {
            timeOutId = setTimeout(() => {
                const newPaginationModel = {
                    page: 0,
                    size: paginationModel.size,
                };

                setPaginationModel(newPaginationModel);

            }, 1000);
        }

        return () => clearTimeout(timeOutId);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchValue]);

    useEffect(() => {
        if (searchValue !== "") {
            filteApiCall(paginationModel);
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [paginationModel])

    const filteApiCall = (newPaginationModel: { page: number, size: number }) => {
        let filterData: any[] = [];
        setIsDataLoaded(true);
        switch (memberFilterValue) {
            case 0:
                fetch(
                    `${baseURL}member/GetMemberReportByGroupIdAndSearchWithMemberName/${searchValue},${selectedGroupId},${newPaginationModel.page},${newPaginationModel.size}`,
                    {
                        headers: {
                            Authorization: `Bearer ${token?.toString()}`
                        }
                    }
                )
                    .then((res) => res.json())
                    .then((data) => {
                        filterData = data.memberReport.map((item: any) => {
                            return {
                                ...item,
                                name: item.firstName + " " + item.lastName,
                                birthday: item?.birthday ? format(new Date(item?.birthday), "MM/dd/yyyy") : "No data",
                                imagePath: item?.imagePath ? `${baseURL}commonFile/Get?name=${item.imagePath}` : "./images/user-default.jpg",
                                address: `${item?.street}, ${item?.city} ${item?.state}, ${item?.country}-${item?.zip}`,
                            };
                        })
                        setSearchTableData(filterData);
                        setTotalLength(data.count);
                        setIsDataLoaded(false);

                    })
                    .catch((error) => {
                        console.log(error);
                        setIsDataLoaded(false);
                        setSearchTableData([]);
                        setTotalLength(0);
                    });

                break;
            case 1:
                fetch(
                    `${baseURL}member/GetMemberReportByGroupIdAndSearchWithFamilyName/${searchValue},${selectedGroupId},${newPaginationModel.page},${newPaginationModel.size}`,
                    {
                        headers: {
                            Authorization: `Bearer ${token?.toString()}`
                        }
                    }
                )
                    .then((res) => res.json())
                    .then((data) => {
                        filterData = data.memberReport.map((item: any) => {
                            return {
                                ...item,
                                name: item.firstName + " " + item.lastName,
                                birthday: item?.birthday ? format(new Date(item?.birthday), "MM/dd/yyyy") : "No data",
                                imagePath: item?.imagePath ? `${baseURL}commonFile/Get?name=${item.imagePath}` : "./images/user-default.jpg",
                                address: `${item?.street}, ${item?.city} ${item?.state}, ${item?.country}-${item?.zip}`,
                            };
                        })

                        setSearchTableData(filterData);
                        setTotalLength(data.count);
                        setIsDataLoaded(false);

                    })
                    .catch((error) => {
                        console.log(error);
                        setIsDataLoaded(false);
                        setSearchTableData([]);
                        setTotalLength(0);
                    });

                break;
            case 2:
                fetch(
                    `${baseURL}member/GetMemberReportByGroupIdAndSearchWithEmailAddress/${searchValue},${selectedGroupId},${newPaginationModel.page},${newPaginationModel.size}`,
                    {
                        headers: {
                            Authorization: `Bearer ${token?.toString()}`
                        }
                    }
                )
                    .then((res) => res.json())
                    .then((data) => {
                        filterData = data.memberReport.map((item: any) => {
                            return {
                                ...item,
                                name: item.firstName + " " + item.lastName,
                                birthday: item?.birthday ? format(new Date(item?.birthday), "MM/dd/yyyy") : "No data",
                                imagePath: item?.imagePath ? `${baseURL}commonFile/Get?name=${item.imagePath}` : "./images/user-default.jpg",
                                address: `${item?.street}, ${item?.city} ${item?.state}, ${item?.country}-${item?.zip}`,
                            };
                        })

                        setSearchTableData(filterData);
                        setTotalLength(data.count);
                        setIsDataLoaded(false);

                    })
                    .catch((error) => {
                        console.log(error);
                        setIsDataLoaded(false);
                        setSearchTableData([]);
                        setTotalLength(0);
                    });

                break;

        }
    }

    const applyFilter = () => {
        setSelectedFilter(() =>
            memberFilterValue === 0 ? "Member Name" : memberFilterValue === 1 ? "Family Name" : "Email"
        );
        setSearchValue("");
        setDisplayFilter(false);
    };

    const clearFilter = () => {
        setSearchValue("");
        setDisplayFilter(false);
    };

    const addMember = () => {
        navigate(`/${pathRoot}/family/addFamily`);
    }

    const deleteMember = (id: string) => {
        navigate(`/${pathRoot}/family/deleteFamily/${id}`);
    }

    const fetchFamiliesForExport = async () => {
        if (selectedGroupId <= 0) {
            return [];
        }

        const response = await fetch(
            `${baseURL}member/GetMemberReportByGroupIdPaging/${selectedGroupId},0,${totalLength || 1000}`,
            {
                headers: {
                    Authorization: `Bearer ${token?.toString()}`
                }
            }
        );

        if (!response.ok) {
            throw new Error("Unable to fetch families for export");
        }

        const data = await response.json();

        return data?.memberReport || [];
    };

    const mapFamilyForExport = (item: any) => ({
        id: item?.id,
        name: item?.familyName || "No Family Name",
        subtitle: item?.firstName
            ? `${item.firstName} ${item.lastName || ""}`.trim()
            : "",
        phone: item?.phoneNumber
            ? formatUSPhone(item.phoneNumber)
            : "",
        email: item?.emailAddress || "",
        image: item?.imagePath
            ? `${baseURL}commonFile/Get?name=${item.imagePath}`
            : ""
    });

    return (
        <section className="user__container p-3 xm:p-4 overflow-x-hidden">
            {/* Header */}
            <div className="min-w-full flex flex-col xm:flex-row justify-between items-start xm:items-center gap-3 text-xs xm:text-sm md:text-base">
                <h1 className="px-2 xm:px-4 py-1.5 flex items-center gap-2">
                    <MdFamilyRestroom fontSize={20} className="xm:text-sm md:text-base lg:text-lg" />
                    <span className="xm:text-sm md:text-base lg:text-lg">Family</span>
                </h1>

                <div className="flex flex-col xm:flex-row gap-2 md:gap-4 w-full xm:w-auto">
                    <ImportView importType="family" />

                    <PdfDirectoryExport
                        title="Families"
                        totalLength={totalLength}
                        exportType="family"
                        fetchData={fetchFamiliesForExport}
                        fetchExcelData={() =>
                            fetchAllMembersForExport(
                                selectedGroupId,
                                auth?.id,
                                auth?.givenname || "",
                                token!
                            )
                        }
                        mapItem={mapFamilyForExport}
                    />

                    <button
                        className="bg-secondary hover:bg-custom-blue px-4 py-2 xm:py-1.5 rounded-sm text-white w-full xm:w-auto"
                        onClick={addMember}
                    >
                        Add Family
                    </button>
                </div>
            </div>

            {/* FILTER + SEARCH */}
            <div className="flex flex-col xm:flex-row gap-3 justify-between xm:items-center border border-black p-2 mt-4">
                <div className="relative flex flex-col xm:flex-row gap-3 items-start xm:items-center w-full">

                    <div className='relative w-full xm:w-auto'>
                        <button
                            className="bg-secondary text-white px-3 py-2 xm:py-1 rounded-md flex items-center justify-between w-full xm:w-auto whitespace-nowrap"
                            onClick={() => setDisplayFilter(!displayFilter)}
                        >
                            {selectedFilter}
                            <RiArrowDownSFill className="ml-1" />
                        </button>

                        <div
                            className={`${displayFilter ? "block" : "hidden"
                                } absolute z-10 w-full xm:w-40 p-2 bg-white border border-black mt-2 xm:mt-0 xm:top-0 xm:left-full`}
                        >
                            <div className="flex justify-between">
                                <label className="text-xs font-bold">Fields</label>
                                <div
                                    onClick={() => setDisplayFilter(false)}
                                    className="w-4 h-4 cursor-pointer text-sm text-center"
                                >
                                    <RxCross1 />
                                </div>
                            </div>

                            <select
                                className="w-full text-xs py-1 border mt-1"
                                value={memberFilterValue}
                                onChange={(e) =>
                                    setMemberFilterValue(parseInt(e.target.value))
                                }
                            >
                                <option value="0">Member Name</option>
                                <option value="1">Family Name</option>
                                <option value="2">Email</option>
                            </select>

                            <div className='flex mt-2 justify-between'>
                                <button
                                    className="text-xs bg-secondary text-white py-1 px-2 rounded-md mt-3 w-full mr-1 whitespace-nowrap"
                                    onClick={() => applyFilter()}
                                >
                                    Apply Filter
                                </button>

                                <button
                                    className="text-xs bg-secondary text-white py-1 px-2 rounded-md mt-3 w-full ml-1"
                                    onClick={() => clearFilter()}
                                >
                                    Clear
                                </button>
                            </div>
                        </div>
                    </div>

                    {/* SEARCH */}
                    <div className="flex items-center gap-2 w-full border px-2 py-1 rounded xm:border-none">
                        <div className="h-4 w-4 text-gray-900">
                            <BsSearch />
                        </div>

                        <input
                            type="text"
                            placeholder="Search…"
                            className="w-full text-sm xm:text-lg pl-2 outline-none"
                            value={searchValue}
                            onChange={(e) => setSearchValue(e.target.value)}
                        />
                    </div>
                </div>
            </div>

            <div className="mt-4" />

            {!isDataLoaded ? (
                <>
                    {searchTableData.length > 0 ? (
                        <div className="member__list__container grid grid-cols-1 3lg:grid-cols-2 gap-y-4 gap-x-2 m-auto w-full">
                            {searchTableData.slice(0, showEntries).map((item, index) => (
                                <div
                                    key={index}
                                    className="member__view__container flex flex-col xm:flex-row w-full h-fit gap-4 md:gap-8 bg-gray-50 shadow-2xl rounded-md p-3 xm:p-2"
                                >
                                    <div className="member__view flex flex-col xm:flex-row gap-3 md:gap-4 w-full md:w-4/6">

                                        <img
                                            src={item.imagePath}
                                            alt="member"
                                            className="w-full xm:w-[150px] xm:h-[150px] object-cover object-top"
                                            onError={({ currentTarget }) => {
                                                currentTarget.onerror = null;
                                                currentTarget.src = "/images/user-default.jpg";
                                            }}
                                        />


                                        <div className="text__container flex flex-col flex-1 justify-between py-2 xm:py-4">
                                            <div className="text-start">
                                                <h1 className="name__text text-base xm:text-lg font-bold break-words">
                                                    {item.familyName}
                                                </h1>

                                                <h3 className="name__text text-xs xm:text-sm font-semibold">
                                                    {item.name}
                                                </h3>
                                            </div>

                                            <div className="mt-1 text-start">
                                                <p className="name__text text-xs xm:text-sm break-words">
                                                    {item.address}
                                                </p>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="family__view flex flex-col-reverse xm:flex-col justify-between py-2 xm:py-4 min-w-[150px] w-full md:w-2/6">
                                        <div className="w-full flex flex-col xm:flex-row justify-end gap-2">
                                            <button
                                                className="bg-secondary hover:bg-custom-blue text-white px-3 py-2 text-xs rounded font-bold w-full xm:w-fit"
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    navigate(`/${pathRoot}/family/view/${item.id}`);
                                                }}
                                            >
                                                View/Edit Family
                                            </button>

                                            <button
                                                className="bg-secondary hover:bg-custom-blue px-3 py-2 rounded text-xs font-bold text-white w-full xm:w-fit"
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    deleteMember(item.id);
                                                }}
                                            >
                                                Delete
                                            </button>
                                        </div>

                                        <div className="text-black text-start mt-3 xm:mt-0">
                                            <div className="flex items-center gap-2 py-1 w-full flex-wrap">
                                                <BsFillTelephoneFill size={15} />
                                                <p className="flex-1 text-sm font-semibold">
                                                    {formatUSPhone(item.phoneNumber || "")}
                                                </p>
                                            </div>

                                            <div className="flex items-center gap-2 py-1 w-full">
                                                <MdEmail size={15} />
                                                <p className="flex-1 text-sm font-semibold break-all">
                                                    {item.emailAddress}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    ) : (
                        <div className="min-w-full h-[120px] flex justify-center items-center">
                            <span className="text-sm">No Data Found</span>
                        </div>
                    )}

                    {totalLength > 0 && (
                        <div className="mt-6 flex flex-col xm:flex-row items-center justify-between gap-3">
                            <Pagination
                                pageOption={[5, 10, 15, 20, 25, 50, 75, 100]}
                                totalLength={totalLength}
                                paginationModel={paginationModel}
                                setPaginationModel={setPaginationModel}
                                showEntries={showEntries}
                                setShowEntries={setShowEntries}
                            />
                        </div>
                    )}
                </>
            ) : (
                <div className="min-w-full h-[300px] xm:h-[480px] flex justify-center items-center">
                    <div className="flex flex-col items-center">
                        <div className="inline-block h-8 w-8 animate-spin rounded-full border-4 border-current border-r-transparent text-secondary"></div>
                        <span className="text-sm mt-2">Loading...</span>
                    </div>
                </div>
            )}
        </section>
    )
}

export default AdminMemberList;